import ACCOUNTING_ACCOUNT_TYPES from "./accountingAccountTypes";
import { addLabelArray } from "helpers/addLabelArray";

const {
  CREATE_ACCOUNTING_ACCOUNT,
  DELETE_ACCOUNTING_ACCOUNT,
  GET_ACCOUNTING_ACCOUNT_LIST,
  GET_SAT_GROUPING_CODES,
  RESTORE_INITIAL_STATE,
  SET_ACCOUNTING_ACCOUNT_SEARCH_FILTERS,
  UPDATE_ACCOUNTING_ACCOUNT,
} = ACCOUNTING_ACCOUNT_TYPES;

const initialState = {
  accountingAccountList: [],
  satGroupingCodesList: [],
  station: null,
  hasSearched: false,
};

export const accountingAccountReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_ACCOUNTING_ACCOUNT: {
      const belongsToCurrentStation = state.station && payload.idStation === state.station.id;
      return {
        ...state,
        accountingAccountList: belongsToCurrentStation
          ? [...state.accountingAccountList, payload]
          : state.accountingAccountList,
      };
    }

    case DELETE_ACCOUNTING_ACCOUNT: {
      const filteredList = state.accountingAccountList.filter((acc) => acc.id !== payload);
      return {
        ...state,
        accountingAccountList: filteredList,
      };
    }

    case GET_ACCOUNTING_ACCOUNT_LIST:
      // Respuesta de una planta que ya no está seleccionada (se cambió durante la búsqueda).
      if (payload.stationId !== state.station?.id) return state;
      return {
        ...state,
        accountingAccountList: payload.list,
        hasSearched: true,
      };

    case GET_SAT_GROUPING_CODES: {
      const extendedCodes = addLabelArray(payload, "code", "name") || [];
      return {
        ...state,
        satGroupingCodesList: extendedCodes,
      };
    }

    case SET_ACCOUNTING_ACCOUNT_SEARCH_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
        ...(payload.key === 'station' && { hasSearched: false, accountingAccountList: [] }),
      };

    case UPDATE_ACCOUNTING_ACCOUNT: {
      const updatedList = state.accountingAccountList.map(
        (acc) => acc.id === payload.id ? payload : acc
      );
      return {
        ...state,
        accountingAccountList: updatedList,
      };
    }

    case RESTORE_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};
